//////////////////////////////////////////////////////////////////////
// Configuration for listing badges (one pill shown on a card).     //
//////////////////////////////////////////////////////////////////////

// Where a badge's truth lives. Mirrors COLLECTION_SOURCES in util/listingCollections.js.
export const BADGE_SOURCES = {
  AUTHOR: 'author',
  METADATA: 'metadata',
  COMPUTED: 'computed',
};

/**
 * A badge describes one signal that can be shown on a listing.
 *
 * - slug:     Stable identifier. For 'metadata' badges this is the value stored
 *             on the listing; for 'author' and 'computed' badges it is internal.
 * - labelKey: Translation key used on listing cards.
 * - source:   'author'   -> the listing's provider has at least one award
 *             'metadata' -> the slug appears in listing.attributes.metadata.badges
 *             'computed' -> derived at render time, see COMPUTED in util/listingBadges.js
 *
 * ARRAY POSITION IS PRIORITY. A card shows only the first badge that qualifies,
 * so reordering this list is the whole of the ordering rule.
 *
 * A slug stored on a listing but missing from this list renders nothing. That is
 * what makes it safe to tag listings ahead of a deploy, and what makes deleting a
 * line here a safe way to retire a badge.
 */
export const listingBadges = [
  { slug: 'awarded', labelKey: 'ListingBadge.awarded', source: BADGE_SOURCES.AUTHOR },
  { slug: 'popular', labelKey: 'ListingBadge.popular', source: BADGE_SOURCES.METADATA },
  { slug: 'new', labelKey: 'ListingBadge.new', source: BADGE_SOURCES.COMPUTED },
];

// How long a listing counts as new, measured from metadata.publishedAt or createdAt.
export const NEW_LISTING_DAYS = 30;
